<template>
	<div class="main">
		<div class="shm">
			<span>注册完成后，请在微信小程序端登录或下载“淞淞零工”app登录</span>
			<div class="sm">
				<div class="wxxix">微信小程序：<img src="../../assets/ssewm.jpg" class="xcx" /></div>
				<div class="app">
					“淞淞零工”app：
					<el-button type="danger" size="small" class="but" @click="tishi">Android下载</el-button>
					<el-button type="danger" size="small" class="but" @click="tishi">IOS下载</el-button>
				</div>
			</div>
		</div>



		<!-- 步骤指示器 -->
		<div class="step-indicator">
			<div v-for="(step, index) in steps" :key="step.currentstep"
				:class="['step', { 'active': currentStep === step.currentstep, 'completed': currentStep > step.currentstep }]">
				<span class="step-number">{{ step.currentstep + 1 }}</span>
				<span class="step-title">{{ step.title }}</span>
			</div>
		</div>

		<!-- 第一步：基本信息验证 + 协议勾选 -->
		<div class="zhuce-card" v-if="currentStep === 0">
			<div class="zhuce-header">
				<h2 class="zhuce-title">基本信息验证</h2>
				<p class="zhuce-subtitle">请填写您的真实信息并同意相关协议</p>
			</div>

			<div class="form-group">
				<label class="form-label">真实姓名</label>
				<input v-model="ZCobj.name" type="text" placeholder="请输入您的真实姓名" class="form-input"
					:class="{ 'error': errors.name }" />
				<span class="error-message" v-if="errors.name">{{ errors.name }}</span>
			</div>

			<div class="form-group">
				<label class="form-label">身份证号</label>
				<input v-model="ZCobj.idCard" type="text" placeholder="请输入您的身份证号码" class="form-input"
					:class="{ 'error': errors.idCard }" />
				<span class="error-message" v-if="errors.idCard">{{ errors.idCard }}</span>
			</div>

			<!-- 协议勾选区域 -->
			<div class="agreement-checkbox" style="margin: 20px 0;">
				<label>
					<input type="checkbox" :checked="agreed" @click="handleCheckboxClick($event)"
						class="custom-checkbox" />
					<span>已阅读并同意</span>
				</label>
				<div class="sm">
					<a class="agreement-link" @click="showAgreement = true">《用户协议》</a>
					<span>和</span>
					<a class="agreement-link" @click="showPrivacy = true">《隐私政策》</a>
				</div>
				<div class="error-message" v-if="errors.agreement">{{ errors.agreement }}</div>
			</div>

			<div class="button-group">
				<button class="next-btn" @click="validateStep1">下一步</button>
			</div>
		</div>

		<!-- 第二步：手机验证 -->
		<div class="zhuce-card" v-if="currentStep === 1">
			<div class="zhuce-header">
				<h2 class="zhuce-title">手机验证</h2>
				<p class="zhuce-subtitle">请验证您的手机号码</p>
			</div>

			<div class="form-group">
				<label class="form-label">手机号码</label>
				<input v-model="ZCobj.phone" type="tel" placeholder="请输入您的手机号码" class="form-input"
					:class="{ 'error': errors.phone }" @input="resetSmsCode" />
				<span class="error-message" v-if="errors.phone">{{ errors.phone }}</span>
			</div>

			<div class="form-group" v-if="!issmsCode">
				<label class="form-label">验证码</label>
				<div class="code-input-group">
					<input v-model="smsCode" type="text" placeholder="请输入验证码" class="form-input code-input"
						:class="{ 'error': errors.smsCode }" />
					<button class="send-code-btn" @click="sendSmsCode" :disabled="isCountingDown">
						{{ countdown > 0 ? `${countdown}s` : '获取验证码' }}
					</button>
				</div>
				<span class="error-message" v-if="errors.smsCode">{{ errors.smsCode }}</span>
			</div>

			<div class="button-group">
				<button class="prev-btn" @click="prevStep">上一步</button>
				<button class="next-btn" @click="validateStep2">下一步</button>
			</div>
		</div>

		<!-- 第三步：选择工种 -->
		<div class="zhuce-card" v-if="currentStep === 2">
			<div class="zhuce-header">
				<h2 class="zhuce-title">选择工种</h2>
				<p class="zhuce-subtitle">请选择您的工种类型</p>
			</div>
			<div class="form-group">
				<div class="typebut">
					<div class="tlbut">
						<button class="add-work-btn" @click="selwork">添加工种</button>
					</div>

					<div class="typearr" v-if="ZCobj.type.length">
						<div v-for="(i,index) in ZCobj.type" :key="i.id"
							:class="['typebutb',{'type-xz':i.id===typeid}]">
							<span class="type-text" @click="xztype(i);set=0">{{i.category}}</span>
							<div class="del" @click="deltype(i.id)">
								<span class="del-icon">×</span>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="fuwulist" v-if="fuwulist.services.length>0">
				<div class="list" v-for="(item,index) in fuwulist.services" :key="item.id">
					{{item.name}}
					<img src="/static/icons/减.png" class="icon-minus" v-if="typeid>=0&&set===1" @click="delfuwu(item)">
				</div>

				<div class="nolist" v-for="(i,ind) in deff" :key="i.id" v-if="deff.length>0">
					{{i.name}}
					<img src="/static/icons/加.png" class="icon-minus" @click="addfuwu(i)">
				</div>

				<img src="/static/icons/set.png" class="set" @click="zjfuwu(typeid,fuwulist);set=1"
					v-if="typeid>=0&&set===0">

				<div v-if="typeid>=0&&set===1" class="qrlist" @click="deff=[];set=0">确认</div>
			</div>
			<div class="error-message" v-if="errors.type">{{ errors.type }}</div>
			<div class="button-group">
				<button class="prev-btn" @click="prevStep">上一步</button>
				<button class="next-btn" @click="validateStep3">下一步</button>
			</div>
		</div>

		<!-- 第四步：选择头像 -->
		<div class="zhuce-card" v-if="currentStep === 3">
			<div class="zhuce-header">
				<h2 class="zhuce-title">选择头像</h2>
				<p class="zhuce-subtitle">请选择您的会员头像</p>
			</div>

			<div class="avatar-selection">
				<div class="iconxs">
					<img :src="ZCobj.avatar" class="icontb" @click="icoxz=true">
				</div>
			</div>
			<div class="error-message" v-if="errors.avatar">{{ errors.avatar }}</div>

			<div class="button-group">
				<button class="prev-btn" @click="prevStep">上一步</button>
				<button class="next-btn" @click="validateStep4">下一步</button>
			</div>
		</div>

		<!-- 第五步：会员期限选择 -->
		<div class="zhuce-card" v-if="currentStep === 4">
			<div class="zhuce-header">
				<h2 class="zhuce-title">会员期限</h2>
				<p class="zhuce-subtitle">请选择会员期限并完成注册</p>
			</div>

			<div class="form-group">
				<label class="form-label">会员期限</label>
				<div class="picker-input" :class="{ 'error': errors.duration }" @click="showDurationPicker = true">
					{{ ZCobj.durationText || '请选择会员期限' }}
				</div>
				<span class="error-message" v-if="errors.duration">{{ errors.duration }}</span>
			</div>

			<div class="price-display">
				<span class="price-label">应付金额：</span>
				<span class="price-value">¥{{ ZCobj.fee.toFixed(2) }}</span>
			</div>

			<div class="button-group">
				<button class="prev-btn" @click="prevStep">上一步</button>
				<button class="next-btn" @click="validateStep5">立即开通</button>
			</div>
		</div>

		<!-- 会员期限选择弹窗 -->
		<div class="modal-overlay" v-if="showDurationPicker" @click="showDurationPicker=false">
			<div class="duration-picker" @click.stop>
				<div class="picker-header">
					<h3 class="picker-title">选择会员期限</h3>
					<span class="close-icon" @click="showDurationPicker=false">×</span>
				</div>

				<div class="duration-list">
					<div v-for="(item, index) in durations" :key="index" class="duration-item"
						:class="{ 'active': durationIndex === index }" @click="selectDuration(index)">
						<span class="duration-name">{{ item.name }}</span>
						<span class="duration-price">¥{{ item.fee.toFixed(2) }}</span>
					</div>
				</div>
			</div>
		</div>

		<!-- 头像选择组件 -->
		<div class="icons-modal" v-if="icoxz">
			<div class="preview-modal" v-if="previewVisible" @click="closePreview">
				<div class="preview-content" @click.stop>
					<img :src="previewImage" class="preview-image" @click="closePreview">
					<div class="preview-actions">
						<button class="confirm-btn" @click="confirmSelect">选择</button>
					</div>
				</div>
			</div>

			<div class="iconlist">
				<div class="header">
					选择你的头像
				</div>
				<div class="icon-scroll" @scroll="handleScroll">
					<div class="iconitem">
						<div v-for="(img,index) in icons" :key="index" @click="previewIcon(img.profilePath)">
							<img :src="img.profilePath" class="icon" />
						</div>
					</div>
					<div class="loading-more" v-if="loading">
						<span>加载中...</span>
					</div>
					<div class="no-more" v-if="noMore">
						<span>没有更多了</span>
					</div>
				</div>
				<div class="close-icon" @click="icoxz=false">×</div>
			</div>
		</div>

		<!-- 用户协议弹窗 -->
		<div class="modal-overlay" v-if="showAgreement" @click="showAgreement=false">
			<div class="agreement-modal" @click.stop>
				<div class="picker-header">
					<h3 class="picker-title">用户协议</h3>
					<span class="close-icon" @click="showAgreement=false">×</span>
				</div>
				<div class="agreement-content">
					<h4>一、服务条款</h4>
					<p>1.1 本平台（以下简称“平台”）提供的会员服务，仅面向符合中华人民共和国法律规定的完全民事行为能力人。</p>
					<p>1.2 用户在注册会员前，应仔细阅读并理解本协议全部内容，勾选“同意”即视为接受本协议所有条款。</p>
					<p>1.3 平台有权根据业务发展需要修改本协议，修改后将通过平台公告通知用户，用户继续使用服务即视为接受修改后的协议。</p>

					<h4>二、会员权利与义务</h4>
					<p>2.1 会员有权享受平台提供的对应期限内的服务，包括但不限于工种认证、服务展示等功能。</p>
					<p>2.2 会员应保证注册信息的真实性、准确性和完整性，如信息变更应及时更新，否则由此产生的损失由会员自行承担。</p>
					<p>2.3 会员不得利用平台服务从事违法违规活动，不得侵害第三方合法权益，否则平台有权终止服务并追究其法律责任。</p>

					<h4>三、会员费用与期限</h4>
					<p>3.1 会员应按照选择的期限支付相应费用，费用支付后不予退还，除非平台存在法定或约定的退款情形。</p>
					<p>3.2 会员期限自开通之日起计算，到期后自动失效，如需继续使用需重新办理开通手续。</p>

					<h4>四、免责声明</h4>
					<p>4.1 平台仅提供技术服务平台，不对会员提供的服务质量、真实性承担保证责任，会员与服务接受方之间的纠纷由双方自行解决。</p>
					<p>4.2 因不可抗力、网络故障等非平台原因导致服务中断的，平台不承担赔偿责任，但应及时通知用户并尽力恢复服务。</p>

					<h4>五、其他条款</h4>
					<p>5.1 本协议的成立、生效、履行、解释及纠纷解决，均适用中华人民共和国法律。</p>
					<p>5.2 双方因本协议产生的纠纷，应首先协商解决；协商不成的，任何一方均有权向平台所在地有管辖权的人民法院提起诉讼。</p>
				</div>
			</div>
		</div>

		<!-- 隐私政策弹窗 -->
		<div class="modal-overlay" v-if="showPrivacy" @click="showPrivacy=false">
			<div class="agreement-modal" @click.stop>
				<div class="picker-header">
					<h3 class="picker-title">隐私政策</h3>
					<span class="close-icon" @click="showPrivacy=false">×</span>
				</div>
				<div class="agreement-content">
					<h4>一、隐私保护原则</h4>
					<p>1.1 平台严格遵守《中华人民共和国个人信息保护法》等相关法律法规，致力于保护用户的个人隐私信息。</p>
					<p>1.2 平台仅在提供服务所必需的范围内收集、使用用户信息，未经用户许可不得向第三方泄露。</p>

					<h4>二、收集的信息范围</h4>
					<p>2.1 注册信息：包括用户的真实姓名、身份证号、手机号码、头像等，用于身份验证和会员服务管理。</p>
					<p>2.2 服务信息：包括用户选择的工种、服务项目等，用于提供精准的服务匹配功能。</p>
					<p>2.3 设备信息：包括设备型号、操作系统等，用于优化平台服务体验和保障账户安全。</p>

					<h4>三、信息使用方式</h4>
					<p>3.1 用于提供会员服务，包括身份验证、服务开通、信息展示等。</p>
					<p>3.2 用于改进平台服务，根据用户使用情况优化功能和界面。</p>
					<p>3.3 在法律法规要求或用户同意的情况下，向第三方提供必要的信息。</p>

					<h4>四、信息保护措施</h4>
					<p>4.1 平台采用加密技术、访问控制等安全措施，防止用户信息泄露、丢失或篡改。</p>
					<p>4.2 平台仅授权必要的工作人员访问用户信息，相关人员需遵守严格的保密义务。</p>

					<h4>五、用户权利</h4>
					<p>5.1 用户有权查询、更正自己的个人信息，可通过平台客服申请办理。</p>
					<p>5.2 用户有权注销账户，账户注销后平台将停止使用其信息，并按照法律规定删除或匿名化处理相关数据。</p>

					<h4>六、政策更新</h4>
					<p>6.1 平台可能根据法律法规变化和业务发展需要更新本隐私政策，更新后将通过平台公告通知用户。</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		Getitem
	} from '../../utils/item';
	import {
		iscard, // 身份证验证接口
		phonecode, // 获取验证码接口
		codecheck, // 验证验证码接口
		cost, // 获取会员期限列表接口
		worksave // 提交注册接口
	} from '@/utils/request.js';

	export default {
		data() {
			return {
				// 弹窗控制
				showDurationPicker: false,
				icoxz: false,
				previewVisible: false,
				previewImage: "",
				showAgreement: false,
				showPrivacy: false,

				// 表单状态
				set: 0,
				deff: [],
				alljobs: [],
				currentStep: 0,
				agreed: false, // 协议勾选状态
				smsCode: '',
				countdown: 0,
				timer: null,
				issmsCode: false,
				typeid: -1,
				durationIndex: 0,
				qx: 0,

				// 分页加载
				icons: [],
				loading: false,
				noMore: false,
				currentPage: 1,
				pageSize: 80,

				// 步骤配置
				steps: [{
						title: '基本信息',
						currentstep: 0
					},
					{
						title: '手机验证',
						currentstep: 1
					},
					{
						title: '选择工种',
						currentstep: 2
					},
					{
						title: '选择头像',
						currentstep: 3
					},
					{
						title: '会员期限',
						currentstep: 4
					}
				],

				// 表单数据
				ZCobj: {
					name: '',
					idCard: '',
					phone: '',
					type: [], // 工种列表 [{id, category, services:[]}]
					papersurl: '',
					avatar: '/static/icons/s(0).png',
					duration: 0, // 会员期限（数字）
					durationText: '', // 会员期限文本
					Expire: '', // 到期时间
					fee: 0 // 费用
				},

				// 会员期限列表
				durations: [],

				// 错误信息
				errors: {
					name: '',
					idCard: '',
					phone: '',
					smsCode: '',
					type: '',
					avatar: '',
					duration: '',
					agreement: ''
				}
			};
		},

		watch: {
			"$store.state.typelist": {
				deep: true,
				handler(newVal) {
					if (!newVal) return;
					const index = this.ZCobj.type.findIndex(item => item.id === newVal.id);
					if (index !== -1) {
						this.ZCobj.type.splice(index, 1, {
							...newVal
						});
					} else {
						this.ZCobj.type.push({
							...newVal
						});
					}
				}
			},
			// 页面销毁时清除定时器
			'$route': {
				handler() {
					if (this.timer) clearInterval(this.timer);
				},
				immediate: false
			}
		},

		computed: {
			// 计算当前选中工种的服务列表
			fuwulist() {
				const ss = {
					id: -1,
					services: []
				};
				if (this.typeid === -1) {
					this.ZCobj.type.forEach(res => {
						ss.services = [...ss.services, ...res.services];
					});
				} else {
					const target = this.ZCobj.type.find(res => res.id === this.typeid);
					if (target) ss.services = [...target.services];
				}
				return ss;
			},
			// 倒计时状态
			isCountingDown() {
				return this.countdown > 0;
			}
		},

		async created() {
			// 初始化数据
			await this.initData();
		},

		beforeUnmount() {
			// 清除定时器
			if (this.timer) clearInterval(this.timer);
		},

		methods: {
			tishi() {
				this.$message.success('正在升级中，请稍候...');
			},

			// 初始化页面数据
			async initData() {
				try {
					// 获取工种列表
					const workRes = await Getitem('worktype');
					this.alljobs = workRes.dataList || [];

					// 获取会员期限列表
					await this.getDurationList();

					// 加载头像列表
					await this.loadIcons();
				} catch (error) {
					console.error('初始化失败:', error);
					this.$toast('页面初始化失败，请刷新重试');
				}
			},

			// 获取会员期限列表（真实接口）
			async getDurationList() {
				try {
					const res = await cost();
					if (res.code === 200 && res.data && res.data.length) {
						this.durations = res.data.map(item => ({
							name: item.name,
							value: item.value,
							fee: item.fee
						}));
					} else {
						// 接口异常时使用默认数据
						this.durations = [{
								name: '1个月',
								value: 1,
								fee: 100
							},
							{
								name: '3个月',
								value: 3,
								fee: 270
							},
							{
								name: '6个月',
								value: 6,
								fee: 500
							},
							{
								name: '12个月',
								value: 12,
								fee: 900
							}
						];
					}
				} catch (error) {
					console.error('获取会员期限失败:', error);
					this.$toast('获取会员期限失败，请重试');
					// 接口异常时使用默认数据
					this.durations = [{
							name: '1个月',
							value: 1,
							fee: 100
						},
						{
							name: '3个月',
							value: 3,
							fee: 270
						},
						{
							name: '6个月',
							value: 6,
							fee: 500
						},
						{
							name: '12个月',
							value: 12,
							fee: 900
						}
					];
				}
			},

			// 第一步验证（真实接口）
			async validateStep1() {
				// 表单验证
				const nameValid = this.validateName();
				const idCardValid = this.validateIdCard();
				const agreementValid = this.validateAgreement();

				if (!(nameValid && idCardValid && agreementValid)) return;

				try {
					// 调用身份证验证接口
					const res = await iscard(this.ZCobj.name, this.ZCobj.idCard);
					if (res.code === 200) {
						this.nextStep();
					} else {
						this.errors.idCard = res.msg || '身份证验证失败';
					}
				} catch (error) {
					console.error('身份证验证接口异常:', error);
					this.errors.idCard = '验证服务异常，请稍后重试';
				}
			},

			// 第二步验证（真实接口）
			async validateStep2() {
				// 表单验证
				const phoneValid = this.validatePhone();
				if (!phoneValid) return;

				if (!this.issmsCode) {
					const smsCodeValid = this.validateSmsCode();
					if (!smsCodeValid) return;
				}

				try {
					// 调用验证码验证接口
					// const res = await codecheck({
					// 	phone: this.ZCobj.phone,
					// 	code: this.smsCode
					// });

					this.issmsCode = true;
					this.nextStep();

					this.errors.smsCode = res.msg || '验证码验证失败';

				} catch (error) {
					console.error('验证码验证接口异常:', error);
					this.errors.smsCode = '验证服务异常，请稍后重试';
				}
			},

			// 第三步验证
			validateStep3() {
				this.errors.type = '';
				if (this.ZCobj.type.length === 0) {
					this.errors.type = '请至少添加一个工种';
					return;
				}

				// 检查每个工种是否有服务项
				const hasNoService = this.ZCobj.type.some(item => !item.services || item.services.length === 0);
				if (hasNoService) {
					this.errors.type = '每个工种需至少选择一项服务';
					return;
				}

				this.nextStep();
			},

			// 第四步验证
			validateStep4() {
				this.errors.avatar = '';
				if (!this.ZCobj.avatar || this.ZCobj.avatar === '/static/icons/s(0).png') {
					this.errors.avatar = '请选择头像';
					return;
				}
				this.nextStep();
			},

			// 第五步验证（提交注册）
			async validateStep5() {
				// 表单验证
				const durationValid = this.validateDuration();
				if (!durationValid) return;

				// 构造注册参数
				const registerData = {
					name: this.ZCobj.name,
					idCard: this.ZCobj.idCard,
					phone: this.ZCobj.phone,
					papersurl: this.ZCobj.papersurl,
					avatar: this.ZCobj.avatar,
					duration: this.ZCobj.duration,
					expire: this.ZCobj.Expire,
					list: this.ZCobj.type.map(item => ({
						pId: item.id,
						ids: item.services.map(s => s.id).join(',')
					}))
				};

				try {
					// 调用注册接口
					const res = await worksave(registerData);
					if (res.code === 200) {
						this.$toast('注册成功');
						this.resetForm();
						this.$emit('tologin');
					} else {
						this.$toast(res.msg || '注册失败');
					}
				} catch (error) {
					console.error('注册接口异常:', error);
					this.$toast('注册服务异常，请稍后重试');
				}
			},

			// 发送验证码（真实接口）
			async sendSmsCode() {
				if (!this.validatePhone()) return;

				try {
					const res = await phonecode(this.ZCobj.phone);
					if (res.code === 200) {

						this.countdown = 60;
						if (this.timer) clearInterval(this.timer);
						this.timer = setInterval(() => {
							this.countdown--;
							if (this.countdown <= 0) {
								clearInterval(this.timer);
							}
						}, 1000);
						// this.$toast('验证码已发送至您的手机');
					} else {
						this.errors.smsCode = res.msg || '验证码发送失败';
					}
				} catch (error) {
					console.error('发送验证码接口异常:', error);
					this.errors.smsCode = '发送服务异常，请稍后重试';
				}
			},

			// 选择会员期限
			selectDuration(index) {
				this.durationIndex = index;
				const selected = this.durations[index];
				this.ZCobj.duration = selected.value;
				this.ZCobj.durationText = selected.name;
				this.ZCobj.fee = selected.fee;
				this.ZCobj.Expire = this.calcExpireDate(selected.value);
				this.errors.duration = "";
				this.showDurationPicker = false;
			},

			// 计算到期日期
			calcExpireDate(monthsToAdd) {
				const date = new Date();
				const originalDate = date.getDate();
				date.setMonth(date.getMonth() + monthsToAdd);
				// 处理月份天数差异（如2月30日）
				if (date.getDate() !== originalDate) {
					date.setDate(0);
				}
				return date.toISOString().replace('T', ' ').substring(0, 19);
			},

			// 表单验证方法
			validateName() {
				if (!this.ZCobj.name) {
					this.errors.name = "请输入真实姓名";
					return false;
				} else if (!/^[\u4e00-\u9fa5]{2,10}$/.test(this.ZCobj.name)) {
					this.errors.name = "请输入2-10个中文字符";
					return false;
				} else {
					this.errors.name = "";
					return true;
				}
			},

			validateIdCard() {
				if (!this.ZCobj.idCard) {
					this.errors.idCard = "请输入身份证号码";
					return false;
				} else if (!/(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(this.ZCobj.idCard)) {
					this.errors.idCard = "请输入有效的身份证号码";
					return false;
				} else {
					this.errors.idCard = "";
					return true;
				}
			},

			validatePhone() {
				if (!this.ZCobj.phone) {
					this.errors.phone = "请输入手机号码";
					return false;
				} else if (!/^1[3-9]\d{9}$/.test(this.ZCobj.phone)) {
					this.errors.phone = "请输入有效的手机号码";
					return false;
				} else {
					this.errors.phone = "";
					return true;
				}
			},

			validateSmsCode() {
				if (!this.smsCode) {
					this.errors.smsCode = "请输入验证码";
					return false;
				} else if (!/^\d{4}$/.test(this.smsCode)) {
					this.errors.smsCode = "请输入4位数字验证码";
					return false;
				} else {
					this.errors.smsCode = "";
					return true;
				}
			},

			validateDuration() {
				if (!this.ZCobj.duration) {
					this.errors.duration = "请选择会员期限";
					return false;
				} else {
					this.errors.duration = "";
					return true;
				}
			},

			validateAgreement() {
				console.log('阅读：', this.agreed);
				if (!this.agreed) {
					this.errors.agreement = "请阅读并同意用户协议和隐私政策";
					return false;
				} else {
					this.errors.agreement = "";
					return true;
				}
			},

			// 工种操作方法
			selwork() {
				this.deff = [];
				this.typeid = -1;
				if (this.ZCobj.type.length >= 2) {
					this.$toast('最多只能添加2个工种');
					return;
				}
				// 跳转至工种选择页面（实际项目中替换为路由跳转）
				this.$router.push('/work-type-selection');
			},

			deltype(id) {
				if (this.typeid === id) {
					this.deff = [];
				}
				this.ZCobj.type = this.ZCobj.type.filter(item => item.id !== id);
				this.typeid = -1;
			},

			xztype(i) {
				this.deff = [];
				this.typeid = i.id;
			},

			addfuwu(i) {
				// 移除已选服务
				this.deff = this.deff.filter(item => item.id !== i.id);
				// 添加到当前工种的服务列表
				const targetType = this.ZCobj.type.find(res => res.id === this.typeid);
				if (targetType) {
					targetType.services.push(i);
				}
			},

			delfuwu(item) {
				const targetType = this.ZCobj.type.find(res => res.id === this.typeid);
				if (targetType) {
					// 从服务列表移除
					targetType.services = targetType.services.filter(service => service.id !== item.id);
					// 添加到待选列表
					this.deff.push(item);
					// 若服务列表为空，删除该工种
					if (targetType.services.length === 0) {
						this.deltype(this.typeid);
					}
				}
			},

			zjfuwu(e) {
				const selectedJob = this.alljobs.find(job => job.id === e);
				if (selectedJob && selectedJob.services) {
					// 计算待选服务（工种所有服务 - 已选服务）
					const selectedServices = this.fuwulist.services.map(s => s.id);
					this.deff = selectedJob.services.filter(service => !selectedServices.includes(service.id));
				}
			},

			// 头像操作方法
			async loadIcons() {
				if (this.loading || this.noMore) return;

				this.loading = true;
				try {
					// 实际项目中替换为真实的头像列表接口
					const res = await this.mockLoadIcons();
					if (res.code === 200 && res.data.length) {
						const newIcons = res.data;
						this.icons = this.currentPage === 1 ? newIcons : [...this.icons, ...newIcons];
						this.noMore = newIcons.length < this.pageSize;
						if (!this.noMore) this.currentPage++;
					} else {
						this.noMore = true;
					}
				} catch (error) {
					console.error('加载头像失败:', error);
					this.$toast('加载头像失败，请重试');
				} finally {
					this.loading = false;
				}
			},

			// 模拟头像加载接口（实际项目中替换为真实接口）
			mockLoadIcons() {
				return new Promise((resolve) => {
					const newIcons = [];
					for (let i = 0; i < this.pageSize; i++) {
						newIcons.push({
							profilePath: `/static/icons/s(${this.icons.length + i}).png`
						});
					}
					setTimeout(() => {
						resolve({
							code: 200,
							data: newIcons
						});
					}, 300);
				});
			},

			handleScroll(e) {
				const scrollElement = e.target;
				if (scrollElement.scrollTop + scrollElement.clientHeight >= scrollElement.scrollHeight - 10) {
					this.loadMoreIcons();
				}
			},

			loadMoreIcons() {
				if (!this.noMore) {
					this.loadIcons();
				}
			},

			previewIcon(img) {
				this.previewImage = img;
				this.previewVisible = true;
			},

			closePreview() {
				this.previewVisible = false;
				this.previewImage = "";
			},

			confirmSelect() {
				this.ZCobj.avatar = this.previewImage;
				this.closePreview();
				this.icoxz = false;
			},

			// 通用方法
			nextStep() {
				this.currentStep++;
			},

			prevStep() {
				this.currentStep--;
			},

			resetSmsCode() {
				this.issmsCode = false;
				this.smsCode = '';
				this.errors.smsCode = '';
				this.countdown = 0;
				if (this.timer) clearInterval(this.timer);
			},

			handleCheckboxClick(e) {
				// 直接获取checkbox的实际checked状态，强制同步到agreed
				this.agreed = e.target.checked;
				console.log('协议：', this.agreed);

				// 同步更新错误提示
				if (this.agreed) {
					this.errors.agreement = '';
				} else {
					// 仅在点击下一步时才提示错误，避免勾选前就显示
					this.errors.agreement = '';
				}
			},


			resetForm() {
				this.currentStep = 0;
				this.ZCobj = {
					name: '',
					idCard: '',
					phone: '',
					type: [],
					papersurl: '',
					avatar: '/static/icons/s(0).png',
					duration: 0,
					durationText: '',
					Expire: '',
					fee: 0
				};
				this.agreed = false;
				this.smsCode = '';
				this.countdown = 0;
				this.issmsCode = false;
				this.typeid = -1;
				this.durationIndex = 0;
				this.errors = {
					name: '',
					idCard: '',
					phone: '',
					smsCode: '',
					type: '',
					avatar: '',
					duration: '',
					agreement: ''
				};
			}
		}
	};
</script>

<style scoped>
	.main {
		padding: 20px;
		max-width: 600px;
		margin: 0 auto;
		font-family: Arial, sans-serif;
		margin-top: -60px;
	}

	.step-indicator {
		display: flex;
		justify-content: space-between;
		margin-bottom: 40px;
		padding: 0 20px;
	}

	.step {
		display: flex;
		flex-direction: column;
		align-items: center;
		flex: 1;
		position: relative;
	}

	.step::after {
		content: '';
		position: absolute;
		top: 15px;
		left: 50%;
		right: -50%;
		height: 2px;
		background-color: #e0e0e0;
		z-index: 1;
	}

	.step:last-child::after {
		display: none;
	}

	.step-number {
		width: 20px;
		height: 20px;
		line-height: 20px;
		text-align: center;
		border-radius: 50%;
		background-color: #e0e0e0;
		color: #999;
		font-size: 12px;
		margin-bottom: 5px;
		position: relative;
		z-index: 2;
	}

	.step-title {
		font-size: 12px;
		color: #999;
	}

	.step.active .step-number {
		background-color: #4a90e2;
		color: white;
	}

	.step.active .step-title {
		color: #4a90e2;
		font-weight: bold;
	}

	.step.completed::after {
		background-color: #4a90e2;
	}

	.step.completed .step-number {
		background-color: #4a90e2;
		color: white;
	}

	.step.completed .step-title {
		color: #333;
	}

	.zhuce-card {
		width: 300px;
		background: #FFFFFF;
		border-radius: 8px;
		padding: 20px;
		box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
		margin: 0 auto 20px;
	}

	.zhuce-header {
		margin-bottom: 20px;
		text-align: center;
	}

	.zhuce-title {
		font-size: 18px;
		font-weight: bold;
		color: #333;
		display: block;
		margin-bottom: 5px;
	}

	.zhuce-subtitle {
		font-size: 12px;
		color: #999;
	}

	.form-group {
		position: relative;
		margin-bottom: 15px;
	}

	.form-label {
		font-size: 14px;
		color: #666;
		display: block;
		margin-bottom: 5px;
		text-align: left;
	}

	.form-input {
		height: 40px;
		padding: 0 10px;
		border: 1px solid #E5E5E5;
		border-radius: 4px;
		font-size: 14px;
		background: #F9F9F9;
		width: 100%;
		box-sizing: border-box;
	}

	.form-input.error {
		border-color: #ff4d4f;
	}

	.error-message {
		color: #ff4d4f;
		font-size: 12px;
		margin-top: 5px;
		display: block;
		text-align: left;
	}

	.button-group {
		display: flex;
		justify-content: space-between;
		margin-top: 30px;
	}

	button {
		flex: 1;
		height: 40px;
		line-height: 40px;
		font-size: 15px;
		border-radius: 20px;
		border: none;
		cursor: pointer;
	}

	button+button {
		margin-left: 10px;
	}

	.prev-btn {
		background-color: #f0f0f0;
		color: #333;
	}

	.next-btn,
	.submit-btn,
	.confirm-btn {
		background: linear-gradient(135deg, #4a90e2, #6bb2ff);
		color: white;
	}

	button[disabled] {
		opacity: 0.6;
		cursor: not-allowed;
	}

	.code-input-group {
		display: flex;
	}

	.code-input {
		flex: 1;
		margin-right: 10px;
	}

	.send-code-btn {
		width: 100px;
		height: 40px;
		line-height: 40px;
		font-size: 12px;
		background-color: #f0f0f0;
		color: #333;
		border-radius: 4px;
	}

	.picker-input {
		height: 40px;
		line-height: 40px;
		padding: 0 10px;
		border: 1px solid #e0e0e0;
		border-radius: 4px;
		background-color: #f9f9f9;
		color: #333;
		position: relative;
		cursor: pointer;
	}

	.picker-input::after {
		content: ">";
		position: absolute;
		right: 10px;
		top: 50%;
		transform: translateY(-50%) rotate(90deg);
		color: #999;
	}

	.picker-input.error {
		border-color: #ff4d4f;
	}

	.price-display {
		text-align: right;
		margin: 15px 0;
		font-size: 14px;
	}

	.price-label {
		color: #999;
	}

	.price-value {
		color: #4a90e2;
		font-weight: bold;
		font-size: 18px;
	}

	.agreement-checkbox {
		margin: 20px 0;
		font-size: 12px;
		color: #999;
		display: flex;
		flex-direction: column;
		justify-content: center;
	}

	.agreement-checkbox label {
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.sm {
		margin-top: 8px;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.agreement-link {
		color: #4a90e2;
		margin: 0 12px;
		cursor: pointer;
	}

	.typebut {
		display: flex;
		flex-direction: column;
		justify-content: start;
		align-items: start;
		width: 100%;
		margin-bottom: 8px;
	}

	.typearr {
		width: 100%;
		display: flex;
		justify-content: flex-start;
		flex-wrap: wrap;
		margin-top: 10px;
	}

	.typebutb {
		width: 48%;
		font-size: 12px;
		background-color: #f5f5f5;
		border-radius: 4px;
		box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
		border: 1px solid #e0e0e0;
		margin-right: 8px;
		margin-bottom: 8px;
		display: flex;
		align-items: center;
		justify-content: center;
		height: 30px;
	}

	.typebutb.type-xz {
		background-color: rgba(74, 144, 226, 0.3);
		border-color: #4a90e2;
	}

	.type-text {
		flex: 1;
		text-align: center;
		padding: 5px;
		line-height: 20px;
		cursor: pointer;
	}

	.del {
		width: 25px;
		display: flex;
		align-items: center;
		justify-content: center;
		background-color: #4a90e2;
		color: white;
		height: 100%;
		cursor: pointer;
	}

	.add-work-btn {
		width: auto;
		padding: 0 15px;
	}

	.fuwulist {
		width: 95%;
		margin: 0 auto 10px;
		display: flex;
		flex-wrap: wrap;
		justify-content: flex-start;
		align-items: center;
		border: 1px solid #f0f0f0;
		border-radius: 4px;
		padding: 10px;
		background-color: #f5f5f5;
		box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
		column-gap: 8px;
	}

	.list,
	.nolist {
		border: 1px solid #fff;
		min-width: 50px;
		text-align: center;
		padding: 5px;
		font-size: 12px;
		margin-bottom: 8px;
		border-radius: 4px;
		box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
		position: relative;
		padding-right: 15px;
	}

	.list {
		color: #333;
		background-color: white;
	}

	.nolist {
		color: white;
		background-color: #4a90e2;
	}

	.icon-minus {
		position: absolute;
		right: -3px;
		top: -5px;
		width: 18px;
		height: 18px;
		border-radius: 50%;
		background-color: white;
		cursor: pointer;
	}

	.set {
		width: 20px;
		height: 20px;
		margin-left: 20px;
		cursor: pointer;
	}

	.qrlist {
		margin-left: 30px;
		border: 1px solid white;
		min-width: 40px;
		text-align: center;
		padding: 3px;
		color: white;
		font-size: 12px;
		margin-bottom: 8px;
		border-radius: 4px;
		box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
		background-color: #4a90e2;
		cursor: pointer;
	}

	.avatar-selection {
		height: 150px;
		width: 100%;
		margin-bottom: 15px;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.iconxs {
		width: 125px;
		height: 125px;
		border-radius: 50%;
		border: 3px solid #e0e0e0;
		box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
		overflow: hidden;
		cursor: pointer;
	}

	.icontb {
		width: 125px;
		height: 125px;
		border-radius: 50%;
		object-fit: cover;
	}

	.modal-overlay {
		position: fixed;
		top: 0;
		left: 0;
		width: 100vw;
		height: 100vh;
		background-color: rgba(0, 0, 0, 0.5);
		display: flex;
		align-items: center;
		justify-content: center;
		z-index: 1000;
	}

	.duration-picker,
	.agreement-modal {
		width: 90%;
		max-width: 400px;
		background-color: #fff;
		border-radius: 12px;
		box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
		padding: 15px;
		max-height: 70vh;
	}

	.agreement-modal {
		display: flex;
		flex-direction: column;
	}

	.agreement-content {
		flex: 1;
		overflow-y: auto;
		padding: 10px 0;
		font-size: 13px;
		line-height: 1.8;
		color: #333;
	}

	.agreement-content h4 {
		margin: 15px 0 8px;
		font-size: 14px;
		color: #4a90e2;
	}

	.agreement-content p {
		margin: 5px 0;
		text-indent: 2em;
		text-align: left;
	}

	.picker-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding-bottom: 10px;
		border-bottom: 1px solid #e0e0e0;
		margin-bottom: 10px;
	}

	.picker-title {
		font-size: 16px;
		font-weight: bold;
		color: #333;
	}

	.close-icon {
		font-size: 20px;
		color: #999;
		cursor: pointer;
	}

	.duration-list {
		max-height: 60vh;
		overflow-y: auto;
	}

	.duration-item {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 15px 10px;
		border-bottom: 1px solid #e0e0e0;
		cursor: pointer;
	}

	.duration-item:last-child {
		border-bottom: none;
	}

	.duration-item.active {
		background-color: rgba(74, 144, 226, 0.1);
	}

	.duration-item.active .duration-name,
	.duration-item.active .duration-price {
		color: #4a90e2;
		font-weight: bold;
	}

	.duration-name {
		font-size: 14px;
		color: #333;
	}

	.duration-price {
		font-size: 14px;
		color: #4a90e2;
	}

	.icons-modal {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background-color: rgba(0, 0, 0, 0.3);
		z-index: 200;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.preview-modal {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background-color: rgba(0, 0, 0, 0.8);
		z-index: 300;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.preview-content {
		background-color: #fff;
		border-radius: 8px;
		padding: 15px;
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.preview-image {
		width: 150px;
		height: 150px;
		border-radius: 50%;
		margin-bottom: 20px;
		object-fit: cover;
	}

	.preview-actions {
		display: flex;
		justify-content: space-between;
		width: 100%;
	}

	.iconlist {
		height: 80vh;
		width: 325px;
		background-color: white;
		border-radius: 8px;
		padding: 10px;
		display: flex;
		flex-direction: column;
		position: relative;
	}

	.header {
		width: 100%;
		height: 23px;
		line-height: 23px;
		font-size: 14px;
		font-weight: bold;
		text-align: center;
		border-bottom: 1px solid #e0e0e0;
		padding-bottom: 8px;
		margin-bottom: 8px;
		flex-shrink: 0;
	}

	.icon-scroll {
		flex: 1;
		overflow-y: auto;
	}

	.iconitem {
		width: 100%;
		display: flex;
		justify-content: center;
		flex-wrap: wrap;
		gap: 10px;
		padding-bottom: 10px;
	}

	.icon {
		width: 40px;
		height: 40px;
		border-radius: 50%;
		transition: transform 0.2s;
		cursor: pointer;
		object-fit: cover;
	}

	.icon:active {
		transform: scale(0.95);
	}

	.loading-more,
	.no-more {
		width: 100%;
		text-align: center;
		padding: 10px 0;
		color: #999;
		font-size: 12px;
	}

	.shm {
		position: absolute;
		bottom: 25px;
		left: 50%;
		right: 50%;
		width: 50vw;
		transform: translateX(-50%);
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;

		.sm {
			display: flex;
			gap: 30px;
			align-items: center;

			.wxxix {
				display: flex;
				align-items: center;
				gap: 10px;

				.xcx {
					width: 90px;
					height: 90px;
					border-radius: 10px;
				}
			}

			.app {
				display: flex;
				align-items: center;
				gap: 10px;

				.but {
					border-radius: 15px;
					display: flex;
					align-items: center;
					font-size: 15px;
				}
			}
		}

	}
</style>